import React from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Logout from "../logout/Logout";
import "./header.css";
import Logo from './image.png'
const Header = () => {
    return (
        <header className="header">
            <div className="logo"><img src={Logo} alt="" /></div>

            <nav className="nav-links">
                <NavLink to="/dashbord/" className="btn-archive-menu">
                    Accueil
                </NavLink>
                <Logout />
            </nav>
        </header>
    );
};

export default Header;
